// Tiny dev-only console logger.
// In production builds (NODE_ENV === 'production') these become no-ops, keeping
// the browser console clean while still letting us debug locally.
const isProd = process.env.NODE_ENV === 'production';

export const devError = (...args) => {
  if (!isProd) console.error(...args);
};

export const devWarn = (...args) => {
  if (!isProd) console.warn(...args);
};

export const devLog = (...args) => {
  if (!isProd) console.log(...args);
};
